import React from "react";
import LegalBirdPageLoading from "../../ContentLoader/LegalBirdPageLoading";
import PageContentContainer from "../../Container/PageContentContainer";
import { ProductHeadline } from "../../PageHeadline/PageHeadline";
import CasePaidTaskDefinition from "../../CasePaidTask/CasePaidTaskDefinition";
import CasePaidTaskSubmission from "../../CasePaidTask/CasePaidTaskSubmission";
import CasePaidTaskApproval from "../../CasePaidTask/CasePaidTaskApproval";
import Grid from "@mui/material/Grid";
import NavigationExtensionPaidTask from "../../CasePaidTask/NavigationExtensionPaidTask";
import { PAID_TASK_STATUS_APPROVED } from "../../PaidTask/paidTaskStatus";
import { useCase } from "../../../provider/CaseProvider";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { scrollToAnchor } from "../../../theme/commonStyles";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "../../../services/ReactQuery/reactQueryService";
import { useParams } from "react-router-dom";
import LegalbirdTipTapEditorProvider from "../../LbEditor/LegalbirdTipTapEditorProvider";
import _ from "lodash";
import { saveSessionStorageState } from "../../../services/browserStorageService";
import { Editor } from "@tiptap/react";
import { getEditorHtml } from "../../../services/Editor/editorFunctions";
import { useRegisterRefetchPageData } from "../../../hooks/useRegisterRefetchPageData.ts";

const CasePaidTaskPage = () => {
  const { paidTaskId } = useParams();

  const queryClient = useQueryClient();
  const { product, refreshCase } = useCase();
  // we can't early return here if paidTaskId is not set, because that would make the useQuery hook be called conditionally
  const paidTaskIdAsNumber = parseInt(paidTaskId || "-1");
  const { data: paidTask, isLoading } = useQuery({
    queryKey: queryKeys.item("paid_tasks", paidTaskIdAsNumber),

    queryFn: () =>
      fetchResource("paid_tasks", paidTaskIdAsNumber)
  });

  useRegisterRefetchPageData(() => {
    refreshCase();
    queryClient.invalidateQueries({
      queryKey: queryKeys.item("paid_tasks", paidTaskIdAsNumber),
    });
  });

  if (!paidTaskId) {
    return null;
  }

  if (isLoading || !paidTask || !product) {
    return <LegalBirdPageLoading />;
  }

  if (paidTask.deletedDate || paidTask?.backofficeCase?.id !== product.backofficeCase?.id) {
    return (
      <>
        <Grid container sx={{
          justifyContent: "center"
        }}>
          <Grid>
            <Typography variant={"h3"} sx={{ mt: 1, mb: 1 }}>
              Diese Aufgabe existiert nicht
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  }

  return (
    <>
      {paidTask.status < PAID_TASK_STATUS_APPROVED && <NavigationExtensionPaidTask />}
      <PageContentContainer size={"small"}>
        <ProductHeadline title="Ausgeschriebene Aufgabe zum Fall von" product={product} />
        <div>
          <Box sx={scrollToAnchor} id={"definition"} />
          <CasePaidTaskDefinition paidTask={paidTask} product={product} />
        </div>
        {paidTask.status < PAID_TASK_STATUS_APPROVED && (
          <>
            <div>
              <Box sx={scrollToAnchor} id={"submission"} />
              <LegalbirdTipTapEditorProvider
                placeholder={"Freitext"}
                onUpdate={_.debounce(({ editor }: { editor: Editor }) => {
                  saveSessionStorageState("customPdfHtml" + product.id, getEditorHtml(editor));
                }, 3000)}
                defaultAlignment={"justify"}
              >
                <CasePaidTaskSubmission paidTask={paidTask} product={product} />
              </LegalbirdTipTapEditorProvider>
            </div>
            <div>
              <Box sx={scrollToAnchor} id={"approval"} />
              <CasePaidTaskApproval paidTask={paidTask} product={product} />
            </div>
          </>
        )}
      </PageContentContainer>
    </>
  );
};

export default CasePaidTaskPage;
